import React, { useState, useEffect } from 'react';
import { api } from '../api';
export default function UsersPage() {
  const [users, setUsers]   = useState([]);
  const [hotels, setHotels] = useState([]);
  const [modal, setModal]   = useState(false);
  const [form, setForm]     = useState({ name:'', email:'', password:'', role:'admin', hotel_ids:[] });
  const load = async () => { const [u,h]=await Promise.all([api.users(),api.hotels()]); setUsers(u); setHotels(h); };
  useEffect(() => { load(); }, []);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const toggleHotel = (id) => setForm(f=>({...f, hotel_ids: f.hotel_ids.includes(id)?f.hotel_ids.filter(x=>x!==id):[...f.hotel_ids,id]}));
  const save = async () => {
    try { await api.createUser(form); setModal(false); setForm({name:'',email:'',password:'',role:'admin',hotel_ids:[]}); await load(); }
    catch(e) { alert(e.message); }
  };
  const deactivate = async (id,name) => {
    if (!window.confirm(`Деактивировать ${name}?`)) return;
    try { await api.deleteUser(id); await load(); } catch(e) { alert(e.message); }
  };
  const ROLE_LABELS = { superadmin:'Суперадмин', admin:'Администратор', manager:'Управляющий (Марсала)' };
  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Пользователи</h1>
        <button className="btn btn-primary" onClick={()=>setModal(true)}>+ Добавить</button>
      </div>
      <div className="card">
        <div className="table-wrap">
          <table>
            <thead><tr><th>Имя</th><th>Email</th><th>Роль</th><th>Отели</th><th>Статус</th><th></th></tr></thead>
            <tbody>
              {users.map(u=>(
                <tr key={u.id}>
                  <td><strong>{u.name}</strong></td><td>{u.email}</td>
                  <td><span className={`role-badge role-${u.role}`}>{ROLE_LABELS[u.role]||u.role}</span></td>
                  <td style={{ fontSize:13, color:'#636e72' }}>{u.role==='admin'&&u.hotel_ids?hotels.filter(h=>u.hotel_ids.includes(h.id)).map(h=>h.name).join(', ')||'—':'Все'}</td>
                  <td><span style={{ color:u.is_active?'#00b894':'#d63031', fontWeight:600 }}>{u.is_active?'Активен':'Деактивирован'}</span></td>
                  <td>{u.is_active&&u.role!=='superadmin'&&<button className="btn btn-danger btn-sm" onClick={()=>deactivate(u.id,u.name)}>Деактивировать</button>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {modal && (
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setModal(false)}>
          <div className="modal" style={{ maxWidth:560, maxHeight:'90vh', overflowY:'auto' }}>
            <div className="modal-title">Новый пользователь</div>
            <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
              <div className="form-row">
                <div className="form-group"><label>Имя</label><input value={form.name} onChange={e=>set('name',e.target.value)} /></div>
                <div className="form-group"><label>Роль</label>
                  <select value={form.role} onChange={e=>set('role',e.target.value)}>
                    <option value="admin">Администратор (отель)</option>
                    <option value="manager">Управляющий Марсалы</option>
                    <option value="superadmin">Суперадмин</option>
                  </select>
                </div>
              </div>
              <div className="form-group"><label>Email</label><input type="email" value={form.email} onChange={e=>set('email',e.target.value)} /></div>
              <div className="form-group"><label>Пароль</label><input type="password" value={form.password} onChange={e=>set('password',e.target.value)} /></div>
              {form.role==='admin' && (
                <div className="form-group">
                  <label>Отели (доступные)</label>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:6, maxHeight:200, overflowY:'auto', padding:8, border:'1px solid #dfe6e9', borderRadius:8 }}>
                    {hotels.map(h=>(
                      <label key={h.id} style={{ display:'flex', alignItems:'center', gap:6, cursor:'pointer', fontSize:13 }}>
                        <input type="checkbox" checked={form.hotel_ids.includes(h.id)} onChange={()=>toggleHotel(h.id)} />{h.name}
                      </label>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={()=>setModal(false)}>Отмена</button>
              <button className="btn btn-primary" onClick={save}>Создать</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
